import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { diversifyProducts } from "../lib/diversify";
import ProductCard from "../components/ProductCard";

export default function NovidadesPage() {
  const [products, setProducts] = useState([]);
  const diversifySeed = useMemo(() => Date.now() ^ Math.floor(Math.random() * 1e9), []);
  useEffect(() => {
    api.get("/products", { params: { is_new: true, limit: 500 } })
      .then((r) => setProducts(diversifyProducts(r.data || [], { seed: diversifySeed })));
  }, [diversifySeed]);
  const today = new Date().toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  return (
    <div data-testid="novidades-page">
      <section className="bg-[#1A1A1A] text-white py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="overline text-[#B8A88A] mb-5">New In</p>
          <h1 className="font-display text-5xl md:text-6xl mb-4">Acabaram de chegar</h1>
          <p className="text-white/60 text-sm">Atualizado em {today}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 py-16">
        {products.length === 0 ? (
          <p className="text-center text-[#A8A8A8] italic">Em breve, novas peças.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </section>
    </div>
  );
}
